import { axiosInstance } from "@/helper/axios-instance";
import { Stock, DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useStockCreation() {
  return useMutationWithValidation({
    mutationFn: async (data: Partial<Stock>) => {
      const response = await axiosInstance({
        method: "PUT",
        url:  `Stock/Insert`,
        data: data,
      });

      return response.data as DataAwareResponse<Stock>;
    },
    retry: 2,
    customMessage: {
      success: "Stock created successfully",
    },
  });
}
